import { Pipe, PipeTransform } from '@angular/core';
import { ActionPlanService } from '../shared/services/index';

@Pipe({
    name: 'actionPlanItemStatus',
    standalone: false
})
export class ActionPlanItemStatusPipe implements PipeTransform {
  public statuses: any;

  constructor(private service: ActionPlanService) {
    this.statuses = this.service.getActionPlanItemStatus();
  }

  transform(value: number): any {
    return this.service.getValue(value, this.statuses);
  }
}
